import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/styles";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import BlockIcon from "@mui/icons-material/Block";
import {
  colors,
  fontSize,
  fontWeight,
  padding,
  borderRadius,
  gaps,
} from "theme/defaultStyle";
import { ValidationState } from "entities/UIModel/PolicyManagementRecord";

const Pill = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  gap: gaps.xsmall1,
  fontSize: fontSize.xsmall,
  fontWeight: fontWeight.bold1,
  padding: `${padding.xsmall} ${padding.small}`,
  borderRadius: borderRadius.xlarge,
  textTransform: "uppercase",
  letterSpacing: "0.4px",
  lineHeight: 1.4,
  cursor: "pointer",
  border: `1px solid transparent`,
  "&.passed": {
    backgroundColor: colors.white,
    color: colors.green,
    borderColor: colors.green,
  },
  "&.errors": {
    backgroundColor: colors.white,
    color: colors.red01,
    borderColor: colors.red01,
  },
  "&.not_passed": {
    backgroundColor: colors.grey10,
    color: colors.grey08,
    borderColor: colors.grey09,
  },
  "& svg": {
    fontSize: fontSize.small,
  },
});

interface ValidationPillProps {
  state?: ValidationState;
  errorCount?: number;
  onClick?: () => void;
}

const ValidationPill = ({
  state,
  errorCount = 0,
  onClick,
}: ValidationPillProps) => {
  const resolved: ValidationState =
    state ?? (errorCount > 0 ? "errors" : "passed");

  let label = "Passed";
  let Icon = CheckCircleOutlineIcon;
  if (resolved === "errors") {
    label = `${errorCount || 1} ${errorCount === 1 ? "Error" : "Errors"}`;
    Icon = ErrorOutlineIcon;
  } else if (resolved === "not_passed") {
    label = "Not Passed";
    Icon = BlockIcon;
  }

  return (
    <Pill className={resolved} onClick={onClick} role="button">
      <Icon />
      {label}
    </Pill>
  );
};

export default ValidationPill;
